import React from 'react';
import './TimelineGroupEmptyState.scss';

type Props = {
  text: string;
};

const TimelineGroupEmptyState = ({ text }: Props) => (
  <div className="timeline-list-empty-container d-flex mt-3 mb-3">
    <p className="m-auto">{text}</p>
  </div>
);

export default TimelineGroupEmptyState;
